export default __webpack_public_path__ + "static/media/colby-party-colby.d174d215.gif";